import { useModuleGate } from '@/lib/moduleGate';

/**
 * True when the item page should show "what the record shows" under
 * How sure we are: the knowledge status and confidence read off the item's
 * evidence, values, effort source and origin (src/lib/itemCertainty.ts).
 *
 * Canonical gate (build contract §2.7): the `item_certainty_reading`
 * workspace module. Off by default until the owner says it is ready
 * (2026-10-15); a workspace admin switches it on in Settings → Modules.
 */
export function useItemCertaintyReadingEnabled(): boolean {
  return useModuleGate('item_certainty_reading');
}
